import {combineReducers, configureStore} from '@reduxjs/toolkit';
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import userReducer from './adminuser'
import authReducer from './authority'

const reducers = combineReducers({
    user: userReducer,
    loginAuth: authReducer
})

const persistConfig = {
    key: 'root',
    storage: storage,
    whitelist: ['user', 'loginAuth']
};

const persistedReducer = persistReducer(persistConfig, reducers);

export type RootState = ReturnType<typeof reducers>

export default configureStore({
    reducer: persistedReducer,
})